import { Icon } from "@iconify/react/dist/iconify.js";

import React from "react";

const OrderCardsComp = ({ isLoading, dashboardDetails }) => {
  console.log("Dash", dashboardDetails);

  return (
    <div className="col-12">
      <div className="card radius-12">
        <div className="card-body p-16">
          <div className="row gy-4">
            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[0]?.label || "Published Blogs"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[0]?.value}
                    </h6>
                  </div>

                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    <Icon icon="mdi:post-outline" className="icon" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[1]?.label || "Total Categories"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[1]?.value}
                    </h6>
                  </div>

                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    <Icon icon="mdi:shape-outline" className="icon" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[2]?.label || "Total Tags"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[2]?.value}
                    </h6>
                  </div>

                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    <Icon icon="mdi:tag-outline" className="icon" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[3]?.label || "Total Sliders"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[3]?.value}
                    </h6>
                  </div>
                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    <Icon icon="mdi:image-multiple-outline" className="icon" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[4]?.label || "Total Products"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[4]?.value}
                    </h6>
                  </div>
                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    {/* <Icon icon="mdi:clipboard-text-outline" className="icon" /> */}
                    
                    <Icon icon="mdi:package-variant" className="icon" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[5]?.label || "Total Product Category"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[5]?.value}
                    </h6>
                  </div>
                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    <Icon icon="mdi:layers-outline" className="icon" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-sm-6">
              <div
                className="px-20 py-16 shadow-sm radius-8 h-100 position-relative overflow-hidden card-hover"
                style={{
                  background: "linear-gradient(135deg, #F1F4FB, #FFFFFF)",
                  borderLeft: "3px solid #09243C",
                  borderRadius: "12px",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div>
                    <span
                      className="mb-2  text-primary-disabled text-md"
                      style={{ fontWeight: "600" }}
                    >
                      {dashboardDetails?.[6]?.label || "Total Contact Inquiry"}
                    </span>
                    <h6
                      className=" mb-1 text-primary-600"
                      style={{ fontWeight: "700" }}
                    >
                      {dashboardDetails?.[6]?.value}
                    </h6>
                  </div>
                  <span
                    className="w-44-px h-44-px radius-8 d-inline-flex justify-content-center align-items-center text-2xl"
                    style={{
                      backgroundColor: "#e2e8f5",
                      color: "#09243C",
                    }}
                  >
                    <Icon
                      icon="mdi:message-processing-outline"
                      className="icon"
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCardsComp;
